import React, { useEffect, useState } from "react";

// js
import { changeHeaderBackGround, ActiveLink } from "../js/main";

import { useSelector } from "react-redux";

const Preference = (props) => {
  useEffect(() => {
    changeHeaderBackGround();
  }, []);

  // const { preference } = useSelector((state) => state.user.user);
  const preference = "Chinese";

  const changeMenu = (data) => {
    Object.keys(preferences).map((key) => {
      if (key === preference) {
        setMenu(preferences[key].menu);
        setMenuData(preferences[key][data]);
      }
    });
  };

  const preferences = {
    Chinese: {
      Noodles: [
        {
          name: "Chinese egg noodles",
          price: "25",
          description: "The egg noodles contains some vegetables",
        },
        {
          name: "Chowmein",
          price: "23",
          description: "Chowmein is a stir fried noodles",
        },
        {
          name: "Eggplant Pomodoro Noodle",
          price: "45",
          description: "Eggplant Pomodoro Noodle has pasta and mushrooms",
        },
        {
          name: "Oats Noodles",
          price: "20",
          description: "Oats Noodles is a nutrient-rich dish",
        },
        {
          name: "Pan Fried Noodles",
          price: "23",
          description: "Pan Fried Noodles are made by adding vegetables",
        },
        {
          name: "Paneer Noodles",
          price: "23",
          description: "paneer noodles has cottage cheese",
        },
        {
          name: "Hakka Noodles",
          price: "23",
          description: "Hakka Noodles has lots of vegetables in it",
        },
        {
          name: "Schezwan Noodles",
          price: "23",
          description: "Spring onion is the key ingredient of this dish",
        },
      ],
      Rice: [
        {
          name: "Steamed Rice",
          price: "25",
          description: "Simple Steamed Rice",
        },
        {
          name: "Vegetable Fried Rice(pure)",
          price: "23",
          description: "Vegatable rice has lots of vegetables in it",
        },
        {
          name: "Egg and Veg Fried Rice",
          price: "45",
          description: "Fried Rice with boiled egg and vegetables",
        },
        {
          name: "Fish Fried Rice",
          price: "20",
          description: "Fried Rice with Fish",
        },
        {
          name: "Chicken Fried Rice",
          price: "23",
          description: "Fried Rice are made by adding Chicken to the rice",
        },
        {
          name: "Garlic Prawn Rice",
          price: "23",
          description: "Prawn Rice has garlic to the rice",
        },
        {
          name: "Mixed Fried Rice",
          price: "23",
          description: "Mixed rice has vegetables, seafood and chicken",
        },
        {
          name: "Pinapple & Chicken Fried Rice",
          price: "23",
          description: "Pinapple & Chicken is the key ingredient of this dish",
        },
      ],
      Dumplings: [
        {
          name: "House Specials",
          price: "25",
          description: "Our house special classic Chinese style dim sum",
        },
        {
          name: "Soup Dumplings",
          price: "23",
          description:
            "Is one of our signature dishes. By adding crab meat and steaming",
        },
        {
          name: "Buns",
          price: "45",
          description: "It is filled with moist pork",
        },
        {
          name: "Pan-Fried Dumplings",
          price: "20",
          description: "pan-fried dumplings - that is crunchy and chewy",
        },
        {
          name: "Boiled Dumplings",
          price: "23",
          description: "Freshly-Made savory boiled dumplings - that is soft",
        },
        {
          name: "Steamed Dumplings",
          price: "23",
          description: "Steamed Dumplings Hand",
        },
      ],
      menu: ["Noodles", "Rice", "Dumplings"],
    },
    Italian: {
      Pasta: [
        {
          name: "Fusilli Pasta",
          price: "25",
          description: "Fusilli are cork-screw shaped long pasta",
        },
        {
          name: "Spaghetti Pasta",
          price: "30",
          description:
            "Spaghetti Pasta is fairly common. It is cylindrical and long",
        },
        {
          name: "Lasagna Pasta",
          price: "32",
          description: "Lasagne sheets make delicious casseroles",
        },
        {
          name: "Macaroni",
          price: "35",
          description:
            "Macaroni has two main varieties, durum wheat and Semolina Macaroni",
        },
        {
          name: "Penne Rigate",
          price: "36",
          description: "Penne is a tube-shaped pasta",
        },
        {
          name: "Farfalle Pasta",
          price: "39",
          description: "This pasta is in the shape of a butterfly or a bow-tie",
        },
        {
          name: "Rotelle Pasta",
          price: "40",
          description: "Rotelle has the shape of a Wagon wheel",
        },
      ],
      Lasange: [
        {
          name: "Bianconi Lasagne",
          price: "25",
          description: "Tomatoes sauce and spinach with cheese",
        },
        {
          name: "Vegeterian lasagane",
          price: "30",
          description: "Sauce tomatoes with vegetabels ",
        },
        {
          name: "Veneta Lasagne",
          price: "32",
          description: "Sauce bolognese , bechamel with cheese",
        },
        {
          name: "Ranso Lasagne",
          price: "35",
          description:
            "Spinach , chicken , tomatoes sauce , mushroom with cheese",
        },
        {
          name: "Tani Lasagne",
          price: "36",
          description:
            "Tomatoes sauce , spinach , mozzarella , parmesan , blue cheese , cheddar cheese",
        },
        {
          name: "Tahai Lasagne",
          price: "39",
          description:
            "Tomatoes sauce , onion , mozzarella , bacon , mushroom , parmesan cheese",
        },
        {
          name: "Jimy Lasagne",
          price: "40",
          description: "Mozzarella , spinach , resto sauce",
        },
      ],
      Chips: [
        {
          name: "Classic Fries",
          price: "30",
          description: "Fried crispy potatoes",
        },
        {
          name: "Chunky Fries",
          price: "33",
          description: "Thick does the trick when it comes to fries.",
        },
        {
          name: "Shoestring Fries",
          price: "35",
          description: "Thin cut and crispy fries ",
        },
        {
          name: "Sweet Potato Fries",
          price: "40",
          description: "Fries of Sweet Potato",
        },
      ],
      menu: ["Pasta", "Lasange", "Chips"],
    },
    "Baked Goods": {
      Pastry: [
        {
          name: "Pineapple pastry",
          price: "35",
          description: "Pastry with pineapple",
        },
        {
          name: "Chocolate Pastry",
          price: "35",
          description: "Pastry with lot of chocolate",
        },
        {
          name: "Napoleon Pastry",
          price: "35",
          description: "Layer each sheet of puff with creamed",
        },
        {
          name: "Puff Pastry",
          price: "35",
          description: "Puff pastry has alternating layers of dough and butter",
        },
        {
          name: "Hot Water Crust Pastry",
          price: "35",
          description: "Crust pastry with hot chocolate",
        },
      ],
      Cake: [
        {
          name: "Butter Cake",
          price: "30",
          description: "Cream butter and sugar",
        },
        {
          name: "Food Cake",
          price: "35",
          description: "Angel food cakes has fruites and creams",
        },
        {
          name: "Chocolate cake",
          price: "40",
          description: "Chocolate cake has lot of chocolate in it",
        },
        {
          name: "Red Velvet Cake",
          price: "50",
          description: "Red velvet cake is essentially a butter cake",
        },
        {
          name: "Baked Flourless Cake",
          price: "57",
          description: "flourless chocolate cakes",
        },
      ],
      Cookies: [
        {
          name: "Chocolate Chip Cookies",
          price: "30",
          description: "Chocolate chip cookies are the perennial classic",
        },
        {
          name: "Shortbread Cookies",
          price: "30",
          description:
            "Shortbread cookies has large amount of butter or shortening",
        },
        {
          name: "Macaron Cookies",
          price: "30",
          description:
            "Macarons are meringue-based cookies made with almond meal",
        },
        {
          name: "Biscotti Cookies",
          price: "30",
          description: "Biscotti come in a wide array of flavors and toppings,",
        },
        {
          name: "Butter Cookies",
          price: "30",
          description: "Butter cookies are crispy",
        },
      ],
      menu: ["Pastry", "Cake", "Cookies"],
    },
  };

  const galleryImages = {
    Chinese: [
      {
        image:
          "https://img.freepik.com/free-photo/schezwan-szechwan-hakka-noodles-with-paneer-cottage-cheese-served-bowl-selective-focus_466689-74479.jpg?size=626&ext=jpg",
        name: "Paneer Noodles",
        category: "Noodles",
      },
      {
        image:
          "https://img.freepik.com/free-photo/thai-food-noodles-spicy-boil-with-pork-boil-egg_1150-27967.jpg?size=626&ext=jpg",
        name: "Chinese Egg Noodles",
        category: "Noodles",
      },
      {
        image:
          "https://img.freepik.com/free-photo/schezwan-noodles-szechwan-vegetable-hakka-noodles-chow-mein-is-popular-indo-chinese-recipes-served-bowl-plate-with-wooden-chopsticks_466689-74642.jpg?size=626&ext=jpg",
        name: "Hakka Noodles",
        category: "Noodles",
      },
      {
        image:
          "https://img.freepik.com/free-photo/chicken-fried-rice-is-popular-indian-chinese-indo-chinese-street-food-served-plate-with-chopsticks_466689-74601.jpg?size=626&ext=jpg",
        name: "Chicken Fried Rice",
        category: "Rice",
      },
      {
        image:
          "https://img.freepik.com/free-photo/veg-biryani-veg-pulav-served-round-brass-bowl-selective-focus_466689-75026.jpg?size=626&ext=jpg",
        name: "Vegetable Fried Rice",
        category: "Rice",
      },
      {
        image:
          "https://img.freepik.com/free-photo/side-view-rice-garnish-with-grilled-chicken-cucumber-carrot-bell-pepper-spring-onion_141793-5070.jpg?size=626&ext=jpg",
        name: "Mixed Fried Rice",
        category: "Rice",
      },
      {
        image:
          "https://img.freepik.com/free-photo/traditional-dumpling-momos-served-with-sauce_57665-7764.jpg?size=626&ext=jpg",
        name: "Pan-Fried Dumplings",
        category: "Dumplings",
      },
      {
        image:
          "https://img.freepik.com/free-photo/top-view-little-cooked-dumplings-with-different-ingredients-dark-background-vegetable-dish-dinner-meal-color-dough_140725-159487.jpg?size=626&ext=jpg",
        name: "House Specials",
        category: "Dumplings",
      },
      {
        image:
          "https://img.freepik.com/free-photo/top-view-japanese-dumplings-assortment_23-2148809858.jpg?size=338&ext=jpg",
        name: "Boiled Dumplings",
        category: "Dumplings",
      },
    ],
    Italian: [
      {
        image:
          "https://img.freepik.com/free-photo/macaroni-with-sausage_1339-7981.jpg?size=626&ext=jpg",
        name: "Macaroni",
        category: "Pasta",
      },
      {
        image:
          "https://img.freepik.com/free-photo/penne-carbonara-pasta-with-salmon_74190-2784.jpg?size=626&ext=jpg",
        name: "Penne Rigate",
        category: "Pasta",
      },
      {
        image:
          "https://img.freepik.com/free-photo/dark-plate-with-italian-spaghetti-dark_1220-2752.jpg?size=626&ext=jpg",
        name: "Fusilli Pasta",
        category: "Pasta",
      },
      {
        image:
          "https://img.freepik.com/free-photo/classic-lasagna-with-bolognese-sauce_2829-11237.jpg?size=626&ext=jpg",
        name: "Bianconi Lasagne",
        category: "Lasange",
      },
      {
        image:
          "https://img.freepik.com/free-photo/lasagne-gratinate-alla-emiliana-close-up_323283-1877.jpg?size=626&ext=jpg",
        name: "Tani Lasagne",
        category: "Lasange",
      },
      {
        image:
          "https://img.freepik.com/free-photo/crispy-french-fries-with-ketchup-mayonnaise_1150-26588.jpg?size=626&ext=jpg",
        name: "Classic Fries",
        category: "Chips",
      },
      {
        image:
          "https://img.freepik.com/free-photo/top-view-french-fries-plate-with-salt-shaker-herbs_23-2148701483.jpg?size=338&ext=jpg",
        name: "Sweet potato Fries",
        category: "Chips",
      },
      {
        image:
          "https://img.freepik.com/free-photo/classic-lasagna-with-bolognese-sauce_2829-14066.jpg?size=338&ext=jpg",
        name: "Lasagna Pasta",
        category: "Pasta",
      },
    ],
    "Baked Goods": [
      {
        image:
          "https://assets.epicurious.com/photos/56afe35a4154d00209141c97/6:4/w_1600,c_limit/EP_01272016_-3ingredientflourlesschocolatecake.jpg",
        name: "Flourless Chocolate Cake",
        category: "Cake",
      },
      {
        image:
          "https://img.freepik.com/free-photo/heart-shaped-red-velvet-cake-dark_114579-1588.jpg?size=338&ext=jpg",
        name: "Red Velvel",
        category: "Cake",
      },
      {
        image:
          "https://img.freepik.com/free-photo/closeup-tasty-chocolate-cake-with-chocolate-chunks-baking-sheet_1220-6330.jpg?size=626&ext=jpg",
        name: "Chocolate cake",
        category: "Cake",
      },
      {
        image:
          "https://img.freepik.com/free-photo/puff-pastry-snacks-white-plate-wooden-board_114579-9278.jpg?size=626&ext=jpg",
        name: "Puff Pastry",
        category: "Pastry",
      },
      {
        image:
          "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-57229.jpg?size=626&ext=jpg",
        name: "Napoleon Pastry",
        category: "Pastry",
      },
      {
        image:
          "https://blog.ediblearrangements.com/wp-content/uploads/2020/03/Macaron-Cookies-min-300x180.jpg",
        name: "Macaron Cookies",
        category: "Cookies",
      },
      {
        image:
          "https://img.freepik.com/free-photo/front-view-pile-cookies_23-2148654562.jpg?size=626&ext=jpg",
        name: "Chocolate Chip Cookies",
        category: "Cookies",
      },
      {
        image:
          "https://img.freepik.com/free-photo/many-cookies-are-placed-fabric-then-placed-wooden-table_1150-19682.jpg?size=626&ext=jpg",
        name: "Biscotti Cookiess",
        category: "Cookies",
      },
    ],
  };

  const [menu, setMenu] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    Object.keys(preferences).map((key) => {
      if (key === preference) {
        setMenu(preferences[key].menu);
        setMenuData(preferences[key][preferences[key].menu[0]]);
      }
    });
    Object.keys(galleryImages).map((key) => {
      if (key === preference) {
        setGallery(galleryImages[key]);
      }
    });
  }, [preference]);

  return (
    <main id="main">
      <section id="menu" className="menu pb-0">
        <div class="parallax">
          <div class="container content" style={{ paddingTop: 50 }}>
            <div class="row">
              <div className="col-md-1"></div>
              <div class="col-md-10 col-center card p-4">
                <div class="section-title">
                  <h2 className="animate__animated animate__bounce">
                    Check our tasty <span>Menu</span>
                  </h2>
                </div>
                <div class="row">
                  <div class="col-lg-12 d-flex justify-content-center">
                    <ul id="menu-filters">
                      {menu?.map((data, index) => {
                        return (
                          <li
                            className={`${index === 0 && "filter-active"}`}
                            onClick={() => changeMenu(data)}
                          >
                            {data}
                          </li>
                        );
                      })}
                      {/* <li>Salads</li>
                                            <li>Specialty</li> */}
                    </ul>
                  </div>
                </div>
                <div class="row mt-4">
                  {menuData?.map((data, index) => {
                    if (index % 2 === 1) {
                      return (
                        <div className="col-md-6 pointer-coursor">
                          <div className="d-flex justify-content-between">
                            <span className="animate__animated animate__fadeInRight">
                              {data.name}
                            </span>
                            <span className="font-weight-bold">
                              {data.price}$
                            </span>
                          </div>
                          <p
                            className="text-muted mt-2"
                            style={{ fontSize: 12 }}
                          >
                            {data.description}
                          </p>
                          <p className="border-bottom"></p>
                        </div>
                      );
                    } else {
                      return (
                        <div className="col-md-6 pointer-coursor">
                          <div className="d-flex justify-content-between">
                            <span className="animate__animated animate__fadeInLeft">
                              {data.name}
                            </span>
                            <span className="font-weight-bold">
                              {data.price}$
                            </span>
                          </div>
                          <p
                            className="text-muted mt-2"
                            style={{ fontSize: 12 }}
                          >
                            {data.description}
                          </p>
                          <p className="border-bottom"></p>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="preference" className="pb-5">
        <div className="container">
          <div className="section-title mb-3">
            <h1 className="display-5">
              Gall<span className="text-warning">ery</span>
            </h1>
            <p>We’re not getting younger. Today let’s fight hunger!</p>
          </div>

          <div class="content">
            {gallery?.map((data) => {
              return (
                <a class="card" href="#!">
                  <div
                    class="front"
                    style={{
                      backgroundImage: `url(${data.image})`,
                    }}
                  ></div>
                  <div class="back">
                    <div>
                      <h3 className="text-success">{data.name}</h3>
                      <button class="button mt-4">{data.category}</button>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
        {/* </div> */}
      </section>
    </main>
  );
};

export default Preference;
